'use strict';

function createShowFieldValidation({ formState, setFormValue, }) {
    return function showFieldValidation(fieldName, defaultValue) {
        const field = formState.fields[fieldName];
        const value = formState.values[fieldName];
        const hasError = field.isDirty && field.message;
        const status = hasError ? 'error' : undefined;
        return {
            value: value != null
                ? value
                : defaultValue !== undefined
                    ? defaultValue
                    : getDefaultValueFromType(field.type),
            required: field.isRequired === true ? true : undefined,
            message: field.isDirty ? field.message : undefined,
            status,
            onChange: (value) => setFormValue(fieldName, getFormValue(value)),
        };
    };
}
function getDefaultValueFromType(type) {
    switch (type) {
        case 'enum':
        case 'date':
        case 'string': {
            return '';
        }
        case 'boolean': {
            return false;
        }
        case 'decimal': {
            return 0;
        }
        case 'integer': {
            return 0;
        }
        case 'array': {
            return [];
        }
        default: {
            return '';
        }
    }
}
function isOption(value) {
    if (value != null && typeof value === 'object' && 'value' in value) {
        return true;
    }
    return false;
}
function getFormValue(value) {
    if (value === '') {
        return null;
    }
    if (isOption(value)) {
        return value.value;
    }
    return value;
}

exports.createShowFieldValidation = createShowFieldValidation;
//# sourceMappingURL=showFieldValidation.js.map
